import { type FC, type KeyboardEvent, type MouseEvent, useState } from 'react';
import { Controller } from 'react-hook-form';

import { cn } from '@/lib/utils';

import { Card } from '@/components/atoms/Card';
import { LocalImage } from '@/components/atoms/LocalImage';
import { Title } from '@/components/atoms/Typography/Title';

import type {
    PaymentGatewayCardsProps,
    PaymentGatewayCardsValueType,
} from '../BusinessContactForm.types';
import { PAYMENT_GATEWAY_CARDS_CONFIG } from '../static/formStaticDataConfig';

const PaymentGatewayCards: FC<PaymentGatewayCardsProps> = ({
    defaultCard,
    formProviderConfig,
    setCardName,
}) => {
    const { control } = formProviderConfig;

    const [activeCardId, setActiveCardId] = useState<string>(
        `${defaultCard}-pg-card`,
    );

    const handleCardClick = (
        e: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>,
        name: PaymentGatewayCardsValueType,
        field: any,
    ) => {
        setActiveCardId(e.currentTarget.id);
        field.onChange(name);
        !!setCardName && setCardName('paymentGateway');
    };

    return (
        <>
            <Title
                size="m"
                className="mb-4 mt-8"
            >
                Bramka płatności
            </Title>

            <div className="mb-3 grid grid-cols-3 gap-4">
                <Controller
                    control={control}
                    name="payment_gateway"
                    render={({ field }) => (
                        <>
                            {PAYMENT_GATEWAY_CARDS_CONFIG.map(name => (
                                <Card
                                    variant="shadow"
                                    className={cn(
                                        activeCardId === `${name}-pg-card`
                                            ? 'border-green-500'
                                            : 'border-white',
                                        'flex items-center justify-center border p-3 hover:cursor-pointer hover:border-solid hover:border-green-500',
                                    )}
                                    data-test-id={`business-contact-payment-gateway-card-${name}`}
                                    id={`${name}-pg-card`}
                                    onClick={e =>
                                        handleCardClick(e, name, field)
                                    }
                                    onKeyDown={e =>
                                        handleCardClick(e, name, field)
                                    }
                                    key={name}
                                    tabIndex={0}
                                >
                                    {name === 'Inne' ? (
                                        <Title size="m">{name}</Title>
                                    ) : (
                                        <LocalImage
                                            alt={`logo ${name}`}
                                            src={`/images/logos/pg-logo-${name.toLocaleLowerCase()}.svg`}
                                            width={120}
                                            height={64}
                                        />
                                    )}
                                </Card>
                            ))}
                        </>
                    )}
                />
            </div>
        </>
    );
};

export default PaymentGatewayCards;
